const SVGX = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <title>Check us out on X</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.197266 15.9998C0.197266 7.26245 7.28215 0.179443 16.0218 0.179443C24.7614 0.179443 31.8463 7.26245 31.8463 15.9998C31.8463 24.7371 24.7614 31.8201 16.0218 31.8201C7.28215 31.8201 0.197266 24.7371 0.197266 15.9998Z"
      fill="#535360"
    />
    <path
      transform="translate(8, 8)"
      d="M9.52373 6.77566L15.4811 0H14.0699L8.89493 5.88201L4.7648 0H0L6.24693 8.89549L0 15.9999H1.4112L6.87253 9.78701L11.2352 15.9999H16M1.92053 1.04126H4.08853L14.0688 15.0098H11.9003"
      fill="white"
    />
  </svg>
);

// eslint-disable-next-line import/no-default-export
export default SVGX;
